import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import { translator } from 'mage-i18n';
import { Typography, ButtonPrimary, IllustrationShopping, SpacerVertical } from '@klarna/bubble-ui';

import { getAfterFlowStepForMerchantApplication } from '../flow/configs/selectors';

const styles = {
  wrapperStyle: {
    width: 500,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: 'auto',
  },
};

const tPrefix = 'products-fe.pages.success_page';

export class ApplicationSuccess extends React.Component {
  constructor() {
    super();

    this.goToWhatsNext = this.goToWhatsNext.bind(this);
  }

  goToWhatsNext() {
    const { afterFlowStep, basePath, history } = this.props;

    history.push(`${basePath}/${afterFlowStep}` + history.location.search);
  }

  render() {
    const { t } = this.props;

    return (
      <div style={styles.wrapperStyle}>
        <IllustrationShopping />
        <SpacerVertical medium />
        <Typography textToken="text-style/headings/titles/bold/tertiary" align="center">
          {t(`${tPrefix}.title`)}
        </Typography>
        <SpacerVertical extraSmall />
        <Typography textToken="text-style/text/super-paragraphs/body/regular" align="center">
          {t(`${tPrefix}.subtitle`)}
        </Typography>
        <SpacerVertical medium />
        <ButtonPrimary onClick={this.goToWhatsNext}>{t(`${tPrefix}.buttons.next`)}</ButtonPrimary>
      </div>
    );
  }
}

ApplicationSuccess.propTypes = {
  afterFlowStep: PropTypes.string.isRequired,
  basePath: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

export default compose(
  connect(state => ({
    afterFlowStep: getAfterFlowStepForMerchantApplication(state),
    t: translator(state),
  })),
)(ApplicationSuccess);
